// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../baseQuery';

import { type Family, type FamilyRequestModel } from './familyModels';

// Define a service using a base URL and expected endpoints
export const familyApi = createApi({
  reducerPath: 'familyApi',
  baseQuery: baseQuery('public/familles', true),
  endpoints: (builder) => {
    return {
      //login: builder.mutation<LoginResponseModel, LoginRequestModel>({
      //    query: generateQuery('login', (response, body: LoginResponseModel) => {
      //        return true || body?.result?.code === ResponseCodes.RESPONSE_CODE_SUCCESS;
      //    }),
      //    transformResponse: (x: any) => {
      //        return x;
      //    },
      //}),
      //updatePost: builder.mutation<Post, Post>({
      //    query: (body: any) => ({
      //        url: '/',
      //        method: 'POST',
      //        body,
      //    }),
      //}),
      getFamilies: builder.query<Family[], FamilyRequestModel>({
        query: ({ univers_uuid, lang, pays_uuid, satc_mode }) => {
          return {
            url: '',
            method: 'get',
            params: {
              univers_uuid,
              lang,
              pays_uuid,
              ...(satc_mode ? { satc_mode: 'true' } : {}),
            },
          };
        },
      }),
      getFamily: builder.query<Family, FamilyRequestModel>({
        query: ({ univers_uuid, lang, pays_uuid, id, satc_mode }) => {
          return {
            url: `${id ?? ''}`,
            method: 'get',
            params: {
              univers_uuid,
              lang,
              pays_uuid,
              ...(satc_mode ? { satc_mode: 'true' } : {}),
            },
          };
        },
      }),
    };
  },
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetFamiliesQuery, useLazyGetFamiliesQuery, useGetFamilyQuery } = familyApi;
